import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { PlusIcon } from '@/components/ui/icons/PlusIcon';

interface NewChatButtonProps {
  onClick: () => void;
  collapsed?: boolean;
}

export function NewChatButton({ onClick, collapsed = false }: NewChatButtonProps) {
  const { t } = useTranslation('common');

  return (
    <Button
      onClick={onClick}
      variant="outline"
      className={`bg-white border-none rounded-sm flex gap-2 transition-all duration-200 ${
        collapsed ? 'w-full !justify-center !px-2 !py-2.5' : 'w-full !justify-start !px-2 !py-2.5'
      }`}
      data-testid={collapsed ? 'new-chat-button-collapsed' : 'new-chat-button-expanded'}
    >
      <div className="flex-shrink-0">
        <PlusIcon />
      </div>
      {!collapsed && (
        <span className="text-sm font-medium whitespace-nowrap">{t('chats.newConversation')}</span>
      )}
    </Button>
  );
}
